import React from 'react';
import PropTypes from 'prop-types';
import { FDSecondaryActionButton } from '@facet-wealth/design';
import { hrefByRelationship } from 'Views/Page/Content/Templates';
import { assertSafeSpreadAttributes } from 'Packages/FacetCore/Experimental/helpers';
import { useNavigateByRelationshipOnClick } from 'Views/Page/Hooks/useNavigateByRelationshipOnClick';

export const SecondaryActionButtonRel = ({
  relationship, beforeOnClick, overrideOnClick, afterSuccessfulOnClick, loading: forceLoading, disabled, alignSelf, label, size, forceFocusMode, iconPosition, isFullWidth, ...rest
}) => {
  const { onClick, loading } = useNavigateByRelationshipOnClick(relationship, {
    beforeOnClick,
    overrideOnClick,
    afterSuccessfulOnClick,
    forceLoading,
    forceFocusMode,
  });

  assertSafeSpreadAttributes(rest);

  // The relationship could have been missing, in which case we shouldn't render
  if (!relationship) {
    return null;
  }

  return (
    <FDSecondaryActionButton
      {...rest}
      size={size}
      icon={relationship.meta('icon')}
      iconPosition={iconPosition}
      alignSelf={alignSelf}
      label={label || relationship.meta('prompt')}
      loading={loading}
      onClick={onClick}
      disabled={disabled || relationship.meta('disabled')}
      href={hrefByRelationship(relationship)}
      isFullWidth={isFullWidth}
    />
  );
};

SecondaryActionButtonRel.propTypes = {
  forceFocusMode: PropTypes.bool,
  relationship: PropTypes.object,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  size: PropTypes.string,
  iconPosition: PropTypes.string,
  alignSelf: PropTypes.oneOf(['flex-start', 'center', 'flex-end', undefined]),
};
